import { ClassCast } from '@utilities/object-helper';

export class EtdrPointsEntity {
    distance: number;
    magnitude: number;
}
export class UpStreamChannel {
    frequency: number;
    txPower: number;
    icfr: number;
    bandwidth: number;
    groupDelay: number;
    etdr: number;
    mer: number;
    portMer: number;
    pmt: number;
    locked: boolean;
    icfrPoints: number[];
    impulsePoints: number[];
    phasePoints: number[];
    groupDelayPoints: number[];
    @ClassCast(EtdrPointsEntity)
    etdrPoints: EtdrPointsEntity[];
    channelType: string;
}
